// extracted by mini-css-extract-plugin
export default {"container":"canoe_container__D5i4X","text":"canoe_text__+mAjO"};